function parseJson(raw, fallback = null) {
  if (raw == null || raw === "") return fallback;
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

/** Extract human seat labels from ticket_booking_line.seat_section_json. */
export function seatLabelsFromSection(raw) {
  const parsed = parseJson(raw, null);
  if (!parsed) return [];
  if (Array.isArray(parsed)) {
    return parsed.map((s) => String(s).trim()).filter(Boolean);
  }
  if (Array.isArray(parsed.seats)) {
    return parsed.seats.map((s) => String(s).trim()).filter(Boolean);
  }
  if (typeof parsed.seats === "string") {
    return parsed.seats.split(/[\n,]+/).map((s) => s.trim()).filter(Boolean);
  }
  if (Array.isArray(parsed.sections)) {
    return parsed.sections.flatMap((section) => (
      Array.isArray(section?.seats)
        ? section.seats.map((s) => String(s).trim()).filter(Boolean)
        : []
    ));
  }
  return [];
}

/** Seat names for booking table; hides mistaken numeric-only qty-as-seat values. */
export function formatBookingLineSeats(line) {
  const fromApi = Array.isArray(line?.seat_labels) ? line.seat_labels : [];
  const labels = fromApi.length ? fromApi : seatLabelsFromSection(line?.seat_section_json);
  const qty = Number(line?.qty || 0);
  const valid = labels.filter((label) => {
    const text = String(label).trim();
    if (!text) return false;
    if (/^\d+$/.test(text) && labels.length === 1 && Number(text) === qty) return false;
    return true;
  });
  return valid.length ? valid.join(", ") : null;
}

export function formatBookingMoney(currency, minor) {
  const amount = Number(minor || 0) / 100;
  return `${currency || "INR"} ${amount.toFixed(2)}`;
}
